var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('proofArchiveList'),_c('modalManageTags'),_c('modalManageTagFilters'),_c('renameItem'),_c('v-tour',{attrs:{"name":"proof-list","steps":_vm.steps,"callbacks":_vm.tourCallbacks}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }